import { history } from "../../../history"
import axios from "axios"
import moment from "moment"
import { getTenant } from "views/pages/mapView/core/Utilities"

const tenant = getTenant();

export const loginWithEmail = (user) => {
  return async dispatch => {
    var userEmail = user.email;

    await axios
      .post("/api/auth/login", {
        username: user.email,
        password: user.password
      })
      .then(response => {
        var token
        var expiration
        var user
        var requiresTwoFactor

        if (response.data) {
          token = response.data.token;
          expiration = response.data.expiration;
          user = response.data.user;
          requiresTwoFactor = response.data.requiresTwoFactor;

          if (requiresTwoFactor === true) {
            dispatch({
              type: "LOGIN_TWO_FACTOR",
              payload: { success: true, user: { userName: userEmail } }
            })
            if (tenant)
              history.push(`/${tenant}/VerifyCode`);
            else
              history.push("/VerifyCode");
          } else {
            localStorage.setItem('token', token);
            localStorage.setItem('expiration', expiration);
            localStorage.setItem('user', JSON.stringify(user));
            var expires_in = moment().diff(moment(expiration)) * (-1);
            setTimeout(logoutTokenExpired, expires_in);

            dispatch({
              type: "LOGIN_WITH_EMAIL",
              payload: { success: true, token: token, expiration: expiration, user: user }
            })
            if (tenant)
              history.push(`/${tenant}/`);
            else
              history.push("/");

            window.location.reload();
          }
        }
      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
      })
  }
}

export const loginWithUrlKey = (urlKey) => {
  return async (dispatch) => {
    try {
      const resp = await axios.get(`/api/auth/LoginUrlKey/${encodeURIComponent(urlKey)}`);
      const data = resp?.data;

      if (!data?.token) {
        dispatch({
          type: "LOGIN_WITH_EMAIL",
          payload: {
            message: "Neplatný přihlašovací odkaz",
            success: false
          }
        });
        return { success: false };
      }

      const { token, expiration, user } = data;

      localStorage.setItem("token", token);
      if (expiration) localStorage.setItem("expiration", expiration);
      localStorage.setItem('user', JSON.stringify(user));

      if (expiration) {
        const expMs = new Date(expiration).getTime();
        const msLeft = Math.max(0, expMs - Date.now());
        clearTimeout(logoutTimeout);
        logoutTimeout = setTimeout(logoutTokenExpired, msLeft);
      }

      dispatch({
        type: "LOGIN_WITH_EMAIL",
        payload: { success: true, token, expiration, user },
      });

      var url = new URL(window.location.href);
      var eventId = url.searchParams.get("detail");

      if (tenant) {
        if (eventId)
          history.push(`/${tenant}/?detail=${eventId}`);
        else
          history.push(`/${tenant}/`);
      }
      else {
        if (eventId)
          history.push(`/?detail=${eventId}`);
        else
          history.push("/");
      }

      return { success: true };
    } catch (err) {
      const errorMsg = err.response?.data?.error_description 
        || err.response?.data?.general?.[0] 
        || "Chyba při přihlašování pomocí odkazu";
      
      dispatch({
        type: "LOGIN_WITH_EMAIL",
        payload: {
          message: errorMsg,
          success: false
        }
      });
      
      history.push(`${tenant ? '/' + tenant : ''}/login`);
      return { success: false, error: err?.message };
    }
  };
};

export const loginTemp = (username) => {
  return async dispatch => {
    await axios
      .post('/api/auth/loginTemp', { 
        username: username, 
        password: '93f38175-b5d0-401a-b242-01814035b30d' 
      })
      .then(response => {
        var token
        var expiration
        var user
        var requiresTwoFactor

        if (response.data) {
          token = response.data.token;
          expiration = response.data.expiration;
          user = response.data.user;
          requiresTwoFactor = response.data.requiresTwoFactor;

          localStorage.setItem('token', token);
          localStorage.setItem('expiration', expiration);
          localStorage.setItem('user', JSON.stringify(user));

          var expires_in = moment().diff(moment(expiration)) * (-1);
          setTimeout(logoutTokenExpired, expires_in);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: { success: true, token: token, expiration: expiration, user: user }
          })
          history.push("/");
        }
      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
        return false;
      })
  }
}

export const loginWithIp = () => {
  return async dispatch => {
    await axios
      .get("/api/auth/LoginAsIp", null)
      .then(response => {
        var token
        var expiration
        var user
        var requiresTwoFactor

        if (response.data) {
          token = response.data.token;
          expiration = response.data.expiration;
          user = response.data.user;
          requiresTwoFactor = response.data.requiresTwoFactor;

          localStorage.setItem('token', token);
          localStorage.setItem('expiration', expiration);
          localStorage.setItem('user', JSON.stringify(user));

          var expires_in = moment().diff(moment(expiration)) * (-1);
          setTimeout(logoutTokenExpired, expires_in);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: { success: true, token: token, expiration: expiration, user: user }
          })
          history.push("/");
        }
      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
        return false;
      })
  }
}

export const loginSwitchUser = user => {
  return async dispatch => {
    var token = localStorage.getItem('token');
    var config = { headers: { Authorization: `Bearer ${token}` } }

    await axios
      .get("/api/Auth/SwitchUser/" + user, { 
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
      })
      .then(response => {
        var token
        var expiration
        var user
        var requiresTwoFactor

        if (response.data) {
          token = response.data.token;
          expiration = response.data.expiration;
          user = response.data.user;
          requiresTwoFactor = response.data.requiresTwoFactor;

          localStorage.setItem('token', token);
          localStorage.setItem('expiration', expiration);
          localStorage.setItem('user', JSON.stringify(user));

          var expires_in = moment().diff(moment(expiration)) * (-1);
          setTimeout(logoutTokenExpired, expires_in);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: { success: true, token: token, expiration: expiration, user: user }
          })

          axios.get("/api/Activity/Last/" + user.personID, config).then(response => {
            if (response.status === 200 || response.status === 204) {
              let object = {
                "id": response.data.id,
                "activityType": response.data.activityType,
                "begin": response.data.begin,
                "end": response.data.end,
                "time": response.data.time,
                "taskID": response.data.taskID,
                "task": response.data.task,
                "activityInterruptionType": response.data.activityInterruptionType,
                "activityInterruptionTypeID": response.data.activityInterruptionTypeID,
                "feature": response.data.feature
              }

              if (response.data.activityType === 0) {
                dispatch({
                  type: "ACTIVITY_ARRIVAL",
                  payload: { lastActivity: object }
                })
              }
              else if (response.data.activityType === 1) {
                dispatch({
                  type: "ACTIVITY_DEPARTURE",
                  payload: { lastActivity: object }
                })
              }
              else if (response.data.activityType === 2) {
                dispatch({
                  type: "ACTIVITY_INTERRUPTION",
                  payload: { lastActivity: object }
                })
              }
              else if (response.data.activityType === 3) {
                dispatch({
                  type: "ACTIVITY_WORK",
                  payload: { lastActivity: object }
                })
              }
            }
            else {
              console.error("Chyba při načítání dat ze serveru!")
            }
          }).catch(err => console.error("Nastala chyba: " + err))

          history.push("/")
        }
      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
      })
  }
}

export const LoginResendCode = () => {
  return async dispatch => {
    await axios
      .post("/api/auth/loginresendcode", {
        /*username: user.email,
        password: ''*/
      })
      .then(response => {

      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
      })
  }
}

export const LoginVerifyCode = code => {
  return async dispatch => {
    await axios
      .post("/api/auth/loginverifycode", {
        TwoFactorCode: code
      })
      .then(response => {
        var token
        var expiration
        var user

        if (response.data) {
          token = response.data.token;
          expiration = response.data.expiration;
          user = response.data.user;

          localStorage.setItem('token', token);
          localStorage.setItem('expiration', expiration);
          localStorage.setItem('user', JSON.stringify(user));

          var expires_in = moment().diff(moment(expiration)) * (-1);
          setTimeout(logoutTokenExpired, expires_in);

          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: { success: true, token: token, expiration: expiration, user: user }
          })
          history.push("/")
        }
      })
      .catch(err => {
        if (err.response) {
          var errorMsg = "";
          if (err.response.data.error_description) errorMsg = err.response.data.error_description;
          if (err.response.data.general) errorMsg = err.response.data.general[0];
          if (err.response.data.errors) errorMsg = err.response.data.errors.password[0];
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: errorMsg,
              success: false
            }
          })
        } else if (err.request) {
        } else {
          dispatch({
            type: "LOGIN_WITH_EMAIL",
            payload: {
              message: "error",
              success: false
            }
          })
        }
      })
  }
}

export const logoutWithEmail = () => {
  return async dispatch => {
    try {
      await axios.post("/api/auth/logout", {}, { 
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
      });
    } catch {
      // Ignorujeme chyby při odhlášení
    } finally {
      dispatch({ type: "LOGOUT_WITH_EMAIL", payload: {} })
      localStorage.removeItem('token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      history.push("/login")
    }
  }
}

export const logoutWithoutEmail = () => {
  return async dispatch => {
    dispatch({ type: "LOGOUT_WITHOUT_EMAIL", payload: {} })
    history.push("/login")
  }
}

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('expiration');
  localStorage.removeItem('user');
  localStorage.removeItem('userRole');
  history.push("/login")
}

export const changeRole = role => {
  return dispatch => dispatch({ type: "CHANGE_ROLE", userRole: role })
}

export const changeUser = user => {
  return dispatch => dispatch({ type: "CHANGE_USER", user: user })
}

export const changePassword = (object) => {
  return async dispatch => {
    await axios.post("/api/auth/changepassword", 
      { OldPass: object.oldpass, NewPass: object.newpass }, 
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    ).then(response => {
      dispatch({ type: "CHANGE_PASSWORD", payload: { success: true } })
    })
    .catch(err => {
      if (err.response) {
        var errorMsg = "";
        if (err.response.data.error_description) errorMsg = err.response.data.error_description;
        dispatch({ type: "CHANGE_PASSWORD", payload: { message: errorMsg, success: false } })
      } else {
        dispatch({ type: "CHANGE_PASSWORD", payload: { message: "error", success: false } })
      }
    })
  }
}

export const refreshToken = () => {
  return async dispatch => {
    await axios.post("/api/auth/refreshtoken", {}, { 
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
    })
    .then(response => {
      if (response.data) {
        var token = response.data.token;
        var expiration = response.data.expiration;
        localStorage.setItem('token', token);
        localStorage.setItem('expiration', expiration);
        
        dispatch({ 
          type: "REFRESH_TOKEN", 
          payload: { success: true, token: token, expiration: expiration } 
        });
      }
    })
    .catch(err => { })
  }
}

export const checkToken = () => {
  const currentPath = window.location.pathname;
  const isOnAuthPages = currentPath.includes('/login') || 
                        currentPath.includes('/VerifyCode') || 
                        currentPath.includes('/registration');
  
  if (isOnAuthPages) {
    return;
  }

  const token = localStorage.getItem('token');
  if (!token) {
    return;
  }

  axios.get("/api/auth/checkToken", { 
    headers: { Authorization: `Bearer ${token}` } 
  })
  .then(response => {
    // Token je validní
    //console.log('Token je validní');
  })
  .catch(err => {
    if (err.response && err.response.status === 401) {
      //console.log('Token je neplatný (401), odhlašuji');
      localStorage.removeItem('token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      history.push(`${tenant ? '/' + tenant : ''}/login`);
    } else {
      console.warn('checkToken failed:', err.response?.status, err.message);
    }
  })
}

var logoutTimeout = null;

export const logoutTokenExpired = () => {
  var expires_in = moment().diff(moment(localStorage.getItem("expiration"))) * (-1);
  if (expires_in > 10000) {
    clearTimeout(logoutTimeout);
    logoutTimeout = setTimeout(logoutTokenExpired, expires_in);
  }
  else {
    logout();
  }
}

const tryTokenRefresh = () => {
  var expires_in = moment().diff(moment(localStorage.getItem("expiration"))) * (-1);
  if (expires_in < 60000) {
    axios.post("/api/auth/refreshtoken", {}, { 
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
    })
    .then(response => {
      if (response.data) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('expiration', response.data.expiration);
      }
    })
  }
}

var url = new URL(window.location.href);
var key = url.searchParams.get("urlKey");

if (!key)
  checkToken();

if (key) {
  const urlParams = new URLSearchParams(url.search);
  const params = urlParams ? '?' + urlParams.toString() : '';
  history.push(`${tenant ? '/' + tenant : ''}/login${params}`);
}
else if (localStorage.getItem("token")) {
  var expires_in = moment().diff(moment(localStorage.getItem("expiration"))) * (-1);
  if (expires_in > 0) logoutTimeout = setTimeout(logoutTokenExpired, expires_in);
  else logoutTokenExpired();
}
else {
  const currentPath = window.location.pathname;
  const isOnAuthPages = currentPath.includes('/login') || 
                        currentPath.includes('/VerifyCode') || 
                        currentPath.includes('/registration');
  const token = url.searchParams.get("token");
  const call = url.searchParams.get("call");
  const hasSpecialParams = token || call || key;
  
  if (!isOnAuthPages && !hasSpecialParams) {
    history.push(`${tenant ? '/' + tenant : ''}/login`);
  }
}
// Idle time tracking
var idleTime = 0;
var idleInterval = setInterval(timerIncrement, 60000); // 1 minute

if (typeof document !== 'undefined') {
  document.body.addEventListener("mousemove", (e) => {
    idleTime = 0;
    clearInterval(idleInterval);
    idleInterval = setInterval(timerIncrement, 60000);
    if (localStorage.getItem("expiration")) tryTokenRefresh();
  });
  
  document.body.addEventListener("keypress", (e) => {
    idleTime = 0;
    clearInterval(idleInterval);
    idleInterval = setInterval(timerIncrement, 60000);
    if (localStorage.getItem("expiration")) tryTokenRefresh();
  });
}

function timerIncrement() {
  idleTime = idleTime + 1;
  if (idleTime > 479) { // 8 hours
    if (localStorage.getItem("expiration")) logout();
    else idleTime = 0;
  }
}